<div class="op-input" [ngClass]="{open:isSelectOpen}">
  <div class="flex">
    <img *ngIf="img" class="img-o" src="/assets/images/options/{{img}}.svg" />
    <textarea autoresize [ngClass]="{'fromPopup':fromPopup}" #inputElement placeholder="{{'questionBoard.edit.newOption' | translate}}"
    [formControl]="answerOptionItemString" (keyup.enter)="onEnter()"></textarea>
  </div>
  <div class="flex">
    <div class="select pointer" #trigger (click)="openSelectType()" *ngIf="!fromPopup && !isInFollowQuestion">
      <p class="add-question" translate>followQuestion.add-question</p>
      <img src="/assets/images/popup-recipient/drop-down.svg">
    </div>
    <img class="img-x pointer" [ngClass]="{'disable':isPublic||(isUsed && !isCanBeRemoved)||isSmartQuestion}" (click)="delete()"
      src="/assets/images/popup-recipient/cancel.svg">
  </div>
</div>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOpen]="true" cdkConnectedOverlayBackdropClass="backdrop-selection"
  (backdropClick)="isSelectOpen=false" [cdkConnectedOverlayOpen]="isSelectOpen"
  [cdkConnectedOverlayPositions]="positonArea">
  <div class="overlay-warp">
    <que-question-type-menu [isInFollowUpQuestionPopup]="true" (addTypeQuestionEmit)="addFollowQuestion($event)"></que-question-type-menu>
  </div>
</ng-template>